import ColorChunk from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ColorChunk/index.tsx';
import API from '/home/ec2-user/Youlify-Design/node_modules/dumi/theme-default/builtins/API/index.js';
import Badge from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Badge/index.tsx';
import CodeGroup from '/home/ec2-user/Youlify-Design/node_modules/dumi/theme-default/builtins/CodeGroup/index.js';
import Container from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Container/index.tsx';
import Previewer from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Previewer/index.tsx';
import SourceCode from '/home/ec2-user/Youlify-Design/node_modules/dumi/theme-default/builtins/SourceCode/index.js';
import Table from '/home/ec2-user/Youlify-Design/node_modules/dumi/theme-default/builtins/Table/index.js';
import Tree from '/home/ec2-user/Youlify-Design/node_modules/dumi/theme-default/builtins/Tree/index.js';
import Antd from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Antd.tsx';
import APITable from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/APITable/index.tsx';
import Audio from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Audio/index.tsx';
import ColorPalettes from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ColorPalettes/index.ts';
import ColorPaletteTool from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ColorPaletteTool/index.ts';
import ColorPaletteToolDark from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ColorPaletteToolDark/index.ts';
import ComponentMeta from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ComponentMeta/index.tsx';
import ComponentOverview from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ComponentOverview/index.tsx';
import ComponentTokenTable from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ComponentTokenTable/index.tsx';
import DemoWrapper from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/DemoWrapper/index.tsx';
import IconSearch from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/IconSearch/index.tsx';
import ImagePreview from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ImagePreview/index.tsx';
import InlinePopover from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/InlinePopover/index.tsx';
import InstallDependencies from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/InstallDependencies/index.tsx';
import LocaleLink from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/LocaleLink/index.tsx';
import Palette from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Palette/index.ts';
import ResourceArticles from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ResourceArticles/index.tsx';
import ResourceCards from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/ResourceCards/index.tsx';
import RootToken from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/RootToken/index.ts';
import Sandpack from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Sandpack/index.tsx';
import TokenCompare from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/TokenCompare/index.tsx';
import TokenTable from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/TokenTable/index.tsx';
import Typography from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/Typography/index.ts';
import VideoPlayer from '/home/ec2-user/Youlify-Design/.dumi/theme/builtins/VideoPlayer/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage } from 'dumi';
import { texts as $$contentTexts } from '/home/ec2-user/Youlify-Design/components/alert/index.$tab-design.zh-CN.md?type=text';

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  return (
    <>
      <Suspense fallback={<LoadingComponent />}>
        <><div className="markdown"><h2 id="组件定义"><LocaleLink aria-hidden="true" tabIndex="-1" href="#组件定义" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"组件定义"}</h2><p>{$$contentTexts[0].value}</p></div><DumiDemo {...{
  "demo": {
    "id": "components-alert-index-tab-design-demo-behavior-pattern",
    "inline": true
  },
  "previewerProps": {}
}} /><div className="markdown"><h2 id="基础使用"><LocaleLink aria-hidden="true" tabIndex="-1" href="#基础使用" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"基础使用"}</h2></div><DumiDemo {...{
  "demo": {
    "id": "components-alert-index-tab-design-demo-content"
  },
  "previewerProps": {
    "description": "<p>展示提示内容，也可以配合标题一起使用</p>",
    "title": "了解提示内容",
    "filename": "components/alert/design/demo/content.tsx",
    "pkgDependencyList": {
      "@ant-design/compatible": "^5.1.3",
      "@ant-design/happy-work-theme": "^1.0.0",
      "@ant-design/tools": "^18.0.3",
      "@ant-design/v5-patch-for-react-19": "^1.0.2",
      "@antfu/eslint-config": "^4.0.0",
      "@antv/g6": "^4.8.24",
      "@biomejs/biome": "^1.9.4",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.10",
      "@dnd-kit/core": "^6.2.0",
      "@dnd-kit/modifiers": "^9.0.0",
      "@dnd-kit/sortable": "^10.0.0",
      "@dnd-kit/utilities": "^3.2.2",
      "@emotion/css": "^11.13.5",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@eslint-react/eslint-plugin": "^1.17.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.4.0",
      "@inquirer/prompts": "^7.1.0",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@prettier/sync": "^0.5.4",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@size-limit/file": "^11.1.6",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.6.3",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.6",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/css-tree": "^2.3.10",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.31",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.12",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.10.1",
      "@types/nprogress": "^0.2.3",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/react": "^19.0.1",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@youlify/auth-sdk": "^0.0.3",
      "adm-zip": "^0.5.16",
      "ajv-keywords": "^3.5.2",
      "ali-oss": "^6.21.0",
      "antd-img-crop": "^4.23.0",
      "antd-style": "^3.7.1",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "chalk": "^5.0.0",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "css-tree": "^3.1.0",
      "csstree-validator": "^4.0.1",
      "cypress-image-diff-html-report": "2.2.0",
      "dekko": "^0.2.1",
      "dotenv": "^16.4.5",
      "dumi": "~2.4.20",
      "dumi-plugin-color-chunk": "^2.1.0",
      "env-paths": "^3.0.0",
      "eslint": "^9.23.0",
      "eslint-plugin-compat": "^6.0.1",
      "eslint-plugin-jest": "^28.9.0",
      "eslint-plugin-jsx-a11y": "^6.10.0",
      "eslint-plugin-react-hooks": "^5.2.0",
      "eslint-plugin-react-refresh": "^0.4.14",
      "fast-glob": "^3.3.2",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.2.0",
      "github-slugger": "^2.0.0",
      "glob": "^11.0.0",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "is-ci": "^4.0.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-jsdom": "^29.7.0",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.3.0",
      "lodash": "^4.17.21",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "p-all": "^5.0.0",
      "package-manager-detector": "^1.0.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.4.1",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "rc-footer": "^0.6.8",
      "rc-tween-one": "^3.0.6",
      "rc-virtual-list": "^3.17.0",
      "react": "^19.1.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.1.0",
      "react-draggable": "^4.4.6",
      "react-fast-marquee": "^1.6.5",
      "react-highlight-words": "^0.21.0",
      "react-icons": "^5.4.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-scan": "^0.3.0",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.1",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.1",
      "rimraf": "^6.0.1",
      "runes2": "^1.1.4",
      "schema-utils": "^2.7.1",
      "semver": "^7.6.3",
      "sharp": "^0.34.0",
      "simple-git": "^3.27.0",
      "size-limit": "^11.1.6",
      "spinnies": "^0.5.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.36.0",
      "terser-webpack-plugin": "^5.3.10",
      "tsx": "^4.19.2",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "webpack": "5.88.2",
      "webpack-bundle-analyzer": "^4.10.2",
      "webpack-cli": "5.1.4",
      "xhr-mock": "^2.5.1",
      "@ant-design/colors": "^7.2.0",
      "@ant-design/cssinjs": "^1.23.0",
      "@ant-design/cssinjs-utils": "^1.1.3",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.6.1",
      "@ant-design/react-slick": "~1.1.2",
      "@babel/runtime": "^7.26.0",
      "@rc-component/color-picker": "~2.0.1",
      "@rc-component/mutate-observer": "^1.1.0",
      "@rc-component/qrcode": "~1.0.0",
      "@rc-component/tour": "~1.15.1",
      "@rc-component/trigger": "^2.2.6",
      "@rc-component/util": "^1.2.1",
      "@youlify/icons": "^0.1.19",
      "classnames": "^2.5.1",
      "copy-to-clipboard": "^3.3.3",
      "dayjs": "^1.11.11",
      "keywords": "^0.1.2",
      "rc-cascader": "~3.33.1",
      "rc-checkbox": "~3.5.0",
      "rc-collapse": "~3.9.0",
      "rc-dialog": "~9.6.0",
      "rc-drawer": "~7.2.0",
      "rc-dropdown": "~4.2.1",
      "rc-field-form": "~2.7.0",
      "rc-image": "~7.11.1",
      "rc-input": "~1.8.0",
      "rc-input-number": "~9.5.0",
      "rc-mentions": "~2.20.0",
      "rc-menu": "~9.16.1",
      "rc-motion": "^2.9.5",
      "rc-notification": "~5.6.3",
      "rc-pagination": "~5.1.0",
      "rc-picker": "~4.11.3",
      "rc-progress": "~4.0.0",
      "rc-rate": "~2.13.1",
      "rc-resize-observer": "^1.4.3",
      "rc-segmented": "~2.7.0",
      "rc-select": "~14.16.6",
      "rc-slider": "~11.1.8",
      "rc-steps": "~6.0.1",
      "rc-switch": "~4.1.0",
      "rc-table": "~7.50.4",
      "rc-tabs": "~15.6.0",
      "rc-textarea": "~1.10.0",
      "rc-tooltip": "~6.4.0",
      "rc-tree": "~5.13.1",
      "rc-tree-select": "~5.27.0",
      "rc-upload": "~4.8.1",
      "rc-util": "^5.44.4",
      "scroll-into-view-if-needed": "^3.1.0",
      "throttle-debounce": "^5.0.2"
    },
    "jsx": "import React from 'react';\nimport { Alert, Flex } from 'antd';\nconst Demo = () => (\n  <Flex gap=\"middle\" vertical style={{ maxWidth: 600 }}>\n    <Alert message=\"你好！欢迎使用专业版，你可以根据自身需求添加业务模块。\" />\n    <Alert\n      message=\"帮助信息\"\n      description=\"你好，由于你的良好信用，我们决定赠送你三个月产品会员，欲了解会员特权与活动请进首页会员专区查看。\"\n    />\n  </Flex>\n);\nexport default Demo;\n"
  }
}} /><DumiDemo {...{
  "demo": {
    "id": "components-alert-index-tab-design-demo-type"
  },
  "previewerProps": {
    "description": "<p>配合底色和图标，了解提示类型（成功、信息、警告、错误）</p>",
    "title": "了解提示类型",
    "filename": "components/alert/design/demo/type.tsx",
    "pkgDependencyList": {
      "@ant-design/compatible": "^5.1.3",
      "@ant-design/happy-work-theme": "^1.0.0",
      "@ant-design/tools": "^18.0.3",
      "@ant-design/v5-patch-for-react-19": "^1.0.2",
      "@antfu/eslint-config": "^4.0.0",
      "@antv/g6": "^4.8.24",
      "@biomejs/biome": "^1.9.4",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.10",
      "@dnd-kit/core": "^6.2.0",
      "@dnd-kit/modifiers": "^9.0.0",
      "@dnd-kit/sortable": "^10.0.0",
      "@dnd-kit/utilities": "^3.2.2",
      "@emotion/css": "^11.13.5",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@eslint-react/eslint-plugin": "^1.17.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.4.0",
      "@inquirer/prompts": "^7.1.0",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@prettier/sync": "^0.5.4",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@size-limit/file": "^11.1.6",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.6.3",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.6",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/css-tree": "^2.3.10",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.31",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.12",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.10.1",
      "@types/nprogress": "^0.2.3",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/react": "^19.0.1",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@youlify/auth-sdk": "^0.0.3",
      "adm-zip": "^0.5.16",
      "ajv-keywords": "^3.5.2",
      "ali-oss": "^6.21.0",
      "antd-img-crop": "^4.23.0",
      "antd-style": "^3.7.1",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "chalk": "^5.0.0",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "css-tree": "^3.1.0",
      "csstree-validator": "^4.0.1",
      "cypress-image-diff-html-report": "2.2.0",
      "dekko": "^0.2.1",
      "dotenv": "^16.4.5",
      "dumi": "~2.4.20",
      "dumi-plugin-color-chunk": "^2.1.0",
      "env-paths": "^3.0.0",
      "eslint": "^9.23.0",
      "eslint-plugin-compat": "^6.0.1",
      "eslint-plugin-jest": "^28.9.0",
      "eslint-plugin-jsx-a11y": "^6.10.0",
      "eslint-plugin-react-hooks": "^5.2.0",
      "eslint-plugin-react-refresh": "^0.4.14",
      "fast-glob": "^3.3.2",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.2.0",
      "github-slugger": "^2.0.0",
      "glob": "^11.0.0",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "is-ci": "^4.0.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-jsdom": "^29.7.0",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.3.0",
      "lodash": "^4.17.21",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "p-all": "^5.0.0",
      "package-manager-detector": "^1.0.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.4.1",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "rc-footer": "^0.6.8",
      "rc-tween-one": "^3.0.6",
      "rc-virtual-list": "^3.17.0",
      "react": "^19.1.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.1.0",
      "react-draggable": "^4.4.6",
      "react-fast-marquee": "^1.6.5",
      "react-highlight-words": "^0.21.0",
      "react-icons": "^5.4.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-scan": "^0.3.0",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.1",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.1",
      "rimraf": "^6.0.1",
      "runes2": "^1.1.4",
      "schema-utils": "^2.7.1",
      "semver": "^7.6.3",
      "sharp": "^0.34.0",
      "simple-git": "^3.27.0",
      "size-limit": "^11.1.6",
      "spinnies": "^0.5.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.36.0",
      "terser-webpack-plugin": "^5.3.10",
      "tsx": "^4.19.2",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "webpack": "5.88.2",
      "webpack-bundle-analyzer": "^4.10.2",
      "webpack-cli": "5.1.4",
      "xhr-mock": "^2.5.1",
      "@ant-design/colors": "^7.2.0",
      "@ant-design/cssinjs": "^1.23.0",
      "@ant-design/cssinjs-utils": "^1.1.3",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.6.1",
      "@ant-design/react-slick": "~1.1.2",
      "@babel/runtime": "^7.26.0",
      "@rc-component/color-picker": "~2.0.1",
      "@rc-component/mutate-observer": "^1.1.0",
      "@rc-component/qrcode": "~1.0.0",
      "@rc-component/tour": "~1.15.1",
      "@rc-component/trigger": "^2.2.6",
      "@rc-component/util": "^1.2.1",
      "@youlify/icons": "^0.1.19",
      "classnames": "^2.5.1",
      "copy-to-clipboard": "^3.3.3",
      "dayjs": "^1.11.11",
      "keywords": "^0.1.2",
      "rc-cascader": "~3.33.1",
      "rc-checkbox": "~3.5.0",
      "rc-collapse": "~3.9.0",
      "rc-dialog": "~9.6.0",
      "rc-drawer": "~7.2.0",
      "rc-dropdown": "~4.2.1",
      "rc-field-form": "~2.7.0",
      "rc-image": "~7.11.1",
      "rc-input": "~1.8.0",
      "rc-input-number": "~9.5.0",
      "rc-mentions": "~2.20.0",
      "rc-menu": "~9.16.1",
      "rc-motion": "^2.9.5",
      "rc-notification": "~5.6.3",
      "rc-pagination": "~5.1.0",
      "rc-picker": "~4.11.3",
      "rc-progress": "~4.0.0",
      "rc-rate": "~2.13.1",
      "rc-resize-observer": "^1.4.3",
      "rc-segmented": "~2.7.0",
      "rc-select": "~14.16.6",
      "rc-slider": "~11.1.8",
      "rc-steps": "~6.0.1",
      "rc-switch": "~4.1.0",
      "rc-table": "~7.50.4",
      "rc-tabs": "~15.6.0",
      "rc-textarea": "~1.10.0",
      "rc-tooltip": "~6.4.0",
      "rc-tree": "~5.13.1",
      "rc-tree-select": "~5.27.0",
      "rc-upload": "~4.8.1",
      "rc-util": "^5.44.4",
      "scroll-into-view-if-needed": "^3.1.0",
      "throttle-debounce": "^5.0.2"
    },
    "jsx": "import React from 'react';\nimport { Alert, Flex } from 'antd';\nconst Demo = () => (\n  <Flex gap=\"large\" vertical style={{ maxWidth: 600 }}>\n    <Flex gap=\"middle\" vertical>\n      <div>成功提示</div>\n      <Alert\n        showIcon\n        type=\"success\"\n        message=\"恭喜！你所提交的信息已经审核通过，如有问题请联系客服。\"\n      />\n      <Alert\n        showIcon\n        type=\"success\"\n        message=\"已成功！\"\n        description=\"你所提交的信息已经审核通过，请及时跟进申请状况。如有问题，请联系审核人员或在线客服。\"\n      />\n    </Flex>\n    <Flex gap=\"middle\" vertical>\n      <div>信息提示</div>\n      <Alert\n        showIcon\n        type=\"info\"\n        message=\"你好！欢迎使用专业版，你可以根据自身需求添加业务模块。\"\n      />\n      <Alert\n        showIcon\n        type=\"info\"\n        message=\"帮助信息\"\n        description=\"你好，由于你的良好信用，我们决定赠送你三个月产品会员，欲了解会员特权与活动请进首页会员专区查看。\"\n      />\n    </Flex>\n    <Flex gap=\"middle\" vertical>\n      <div>警告提示</div>\n      <Alert\n        showIcon\n        type=\"warning\"\n        message=\"系统将于 15 : 00 - 17 : 00 进行升级，请及时保存你的资料！\"\n      />\n      <Alert\n        showIcon\n        type=\"warning\"\n        message=\"请注意\"\n        description=\"你所提交的信息已经审核失败，可以进入个人信箱查看原因，如有疑问，请联系客服人员。\"\n      />\n    </Flex>\n    <Flex gap=\"middle\" vertical>\n      <div>错误提示</div>\n      <Alert showIcon type=\"error\" message=\"系统错误，请稍后重试。\" />\n      <Alert\n        showIcon\n        type=\"error\"\n        message=\"出错了！\"\n        description=\"你的账户会员使用权限将在3天后到期，请及时跟进申请状况。如有问题，请联系审核人员。\"\n      />\n    </Flex>\n  </Flex>\n);\nexport default Demo;\n"
  }
}} /><div className="markdown"><h2 id="交互变体"><LocaleLink aria-hidden="true" tabIndex="-1" href="#交互变体" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"交互变体"}</h2></div><DumiDemo {...{
  "demo": {
    "id": "components-alert-index-tab-design-demo-action"
  },
  "previewerProps": {
    "description": "<p>可对提示进行关闭、展开/收起，或执行其他操作</p>",
    "title": "针对提示进行操作",
    "filename": "components/alert/design/demo/action.tsx",
    "pkgDependencyList": {
      "@ant-design/compatible": "^5.1.3",
      "@ant-design/happy-work-theme": "^1.0.0",
      "@ant-design/tools": "^18.0.3",
      "@ant-design/v5-patch-for-react-19": "^1.0.2",
      "@antfu/eslint-config": "^4.0.0",
      "@antv/g6": "^4.8.24",
      "@biomejs/biome": "^1.9.4",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.10",
      "@dnd-kit/core": "^6.2.0",
      "@dnd-kit/modifiers": "^9.0.0",
      "@dnd-kit/sortable": "^10.0.0",
      "@dnd-kit/utilities": "^3.2.2",
      "@emotion/css": "^11.13.5",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@eslint-react/eslint-plugin": "^1.17.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.4.0",
      "@inquirer/prompts": "^7.1.0",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@prettier/sync": "^0.5.4",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@size-limit/file": "^11.1.6",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.6.3",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.6",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/css-tree": "^2.3.10",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.31",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.12",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.10.1",
      "@types/nprogress": "^0.2.3",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/react": "^19.0.1",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@youlify/auth-sdk": "^0.0.3",
      "adm-zip": "^0.5.16",
      "ajv-keywords": "^3.5.2",
      "ali-oss": "^6.21.0",
      "antd-img-crop": "^4.23.0",
      "antd-style": "^3.7.1",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "chalk": "^5.0.0",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "css-tree": "^3.1.0",
      "csstree-validator": "^4.0.1",
      "cypress-image-diff-html-report": "2.2.0",
      "dekko": "^0.2.1",
      "dotenv": "^16.4.5",
      "dumi": "~2.4.20",
      "dumi-plugin-color-chunk": "^2.1.0",
      "env-paths": "^3.0.0",
      "eslint": "^9.23.0",
      "eslint-plugin-compat": "^6.0.1",
      "eslint-plugin-jest": "^28.9.0",
      "eslint-plugin-jsx-a11y": "^6.10.0",
      "eslint-plugin-react-hooks": "^5.2.0",
      "eslint-plugin-react-refresh": "^0.4.14",
      "fast-glob": "^3.3.2",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.2.0",
      "github-slugger": "^2.0.0",
      "glob": "^11.0.0",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "is-ci": "^4.0.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-jsdom": "^29.7.0",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.3.0",
      "lodash": "^4.17.21",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "p-all": "^5.0.0",
      "package-manager-detector": "^1.0.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.4.1",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "rc-footer": "^0.6.8",
      "rc-tween-one": "^3.0.6",
      "rc-virtual-list": "^3.17.0",
      "react": "^19.1.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.1.0",
      "react-draggable": "^4.4.6",
      "react-fast-marquee": "^1.6.5",
      "react-highlight-words": "^0.21.0",
      "react-icons": "^5.4.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-scan": "^0.3.0",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.1",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.1",
      "rimraf": "^6.0.1",
      "runes2": "^1.1.4",
      "schema-utils": "^2.7.1",
      "semver": "^7.6.3",
      "sharp": "^0.34.0",
      "simple-git": "^3.27.0",
      "size-limit": "^11.1.6",
      "spinnies": "^0.5.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.36.0",
      "terser-webpack-plugin": "^5.3.10",
      "tsx": "^4.19.2",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "webpack": "5.88.2",
      "webpack-bundle-analyzer": "^4.10.2",
      "webpack-cli": "5.1.4",
      "xhr-mock": "^2.5.1",
      "@ant-design/colors": "^7.2.0",
      "@ant-design/cssinjs": "^1.23.0",
      "@ant-design/cssinjs-utils": "^1.1.3",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.6.1",
      "@ant-design/react-slick": "~1.1.2",
      "@babel/runtime": "^7.26.0",
      "@rc-component/color-picker": "~2.0.1",
      "@rc-component/mutate-observer": "^1.1.0",
      "@rc-component/qrcode": "~1.0.0",
      "@rc-component/tour": "~1.15.1",
      "@rc-component/trigger": "^2.2.6",
      "@rc-component/util": "^1.2.1",
      "@youlify/icons": "^0.1.19",
      "classnames": "^2.5.1",
      "copy-to-clipboard": "^3.3.3",
      "dayjs": "^1.11.11",
      "keywords": "^0.1.2",
      "rc-cascader": "~3.33.1",
      "rc-checkbox": "~3.5.0",
      "rc-collapse": "~3.9.0",
      "rc-dialog": "~9.6.0",
      "rc-drawer": "~7.2.0",
      "rc-dropdown": "~4.2.1",
      "rc-field-form": "~2.7.0",
      "rc-image": "~7.11.1",
      "rc-input": "~1.8.0",
      "rc-input-number": "~9.5.0",
      "rc-mentions": "~2.20.0",
      "rc-menu": "~9.16.1",
      "rc-motion": "^2.9.5",
      "rc-notification": "~5.6.3",
      "rc-pagination": "~5.1.0",
      "rc-picker": "~4.11.3",
      "rc-progress": "~4.0.0",
      "rc-rate": "~2.13.1",
      "rc-resize-observer": "^1.4.3",
      "rc-segmented": "~2.7.0",
      "rc-select": "~14.16.6",
      "rc-slider": "~11.1.8",
      "rc-steps": "~6.0.1",
      "rc-switch": "~4.1.0",
      "rc-table": "~7.50.4",
      "rc-tabs": "~15.6.0",
      "rc-textarea": "~1.10.0",
      "rc-tooltip": "~6.4.0",
      "rc-tree": "~5.13.1",
      "rc-tree-select": "~5.27.0",
      "rc-upload": "~4.8.1",
      "rc-util": "^5.44.4",
      "scroll-into-view-if-needed": "^3.1.0",
      "throttle-debounce": "^5.0.2"
    },
    "jsx": "import React from 'react';\nimport { Alert, Flex, Typography } from 'antd';\nconst Demo = () => {\n  const [expandA, setExpandA] = React.useState(false);\n  const [expandB, setExpandB] = React.useState(true);\n  return (\n    <Flex gap=\"large\" vertical style={{ maxWidth: 600 }}>\n      <Flex gap=\"middle\" vertical>\n        <div>关闭提示</div>\n        <Alert showIcon closable message=\"你好！欢迎使用专业版，你可以根据自身需求添加业务模块。\" />\n        <Alert\n          showIcon\n          closable\n          message=\"帮助信息\"\n          description=\"你好，由于你的良好信用，我们决定赠送你三个月产品会员，欲了解会员特权与活动请进首页会员专区查看。\"\n        />\n      </Flex>\n      <Flex gap=\"middle\" vertical>\n        <div>展开/收起提示</div>\n        <Alert\n          showIcon\n          closable\n          message={\n            <div>\n              <Typography.Paragraph ellipsis={!expandA && { rows: 2 }} style={{ marginBottom: 8 }}>\n                提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。\n              </Typography.Paragraph>\n              <Typography.Link onClick={() => setExpandA(prev => !prev)}>\n                {expandA ? '收起' : '展开更多'}\n              </Typography.Link>\n            </div>\n          }\n          style={{ alignItems: 'baseline' }}\n        />\n        <Alert\n          showIcon\n          closable\n          message={\n            <div>\n              <Typography.Paragraph ellipsis={!expandB && { rows: 2 }} style={{ marginBottom: 8 }}>\n                提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。提示信息超过2行时，可以使用将部分信息折叠，以减少空间占用。\n              </Typography.Paragraph>\n              <Typography.Link onClick={() => setExpandB(prev => !prev)}>\n                {expandB ? '收起' : '展开更多'}\n              </Typography.Link>\n            </div>\n          }\n          style={{ alignItems: 'baseline' }}\n        />\n      </Flex>\n      <Flex gap=\"middle\" vertical>\n        <div>执行其他操作</div>\n        <Alert\n          showIcon\n          closable\n          message=\"提示信息不超过一行时，按钮放在信息右侧。\"\n          action={<Typography.Link>相关操作</Typography.Link>}\n        />\n        <Alert\n          showIcon\n          closable\n          message={\n            <div>\n              <Typography.Paragraph style={{ marginBottom: 8 }}>\n                提示信息超过一行，此时按钮按照从上至下的视觉流，放置在信息区下方，这样浏览起来更流畅，即先阅读提示信息，再根据信息判断执行什么操作。\n              </Typography.Paragraph>\n              <Flex gap={8}>\n                <Typography.Link>相关操作1</Typography.Link>\n                <Typography.Link>相关操作2</Typography.Link>\n              </Flex>\n            </div>\n          }\n          style={{ alignItems: 'baseline' }}\n        />\n        <Alert\n          showIcon\n          closable\n          message=\"提示标题\"\n          description={\n            <div>\n              <Typography.Paragraph style={{ marginBottom: 8 }}>\n                提示信息超过一行，此时按钮按照从上至下的视觉流，放置在信息区下方，这样浏览起来更流畅，即先阅读提示信息，再根据信息判断执行什么操作。\n              </Typography.Paragraph>\n              <Flex gap={8}>\n                <Typography.Link>相关操作1</Typography.Link>\n                <Typography.Link>相关操作2</Typography.Link>\n              </Flex>\n            </div>\n          }\n        />\n        <Typography.Paragraph type=\"secondary\">\n          建议统一使用Link\n          Button，明确可点击的同时，整体视觉也更和谐；当提示信息不超一行时，按钮放在信息右侧；当提示信息超过一行，按钮放置在信息区下方；这样能够确保用户的浏览动线一致，即先阅读提示信息，再根据信息判断执行什么操作。\n        </Typography.Paragraph>\n      </Flex>\n    </Flex>\n  );\n};\nexport default Demo;\n"
  }
}} /></>
      </Suspense>
    </>
  )
}

export default DumiMarkdownContent;